export enum EstatusRespuesta {
    OK=200,
    NOT_FOUND=404,
    UNAUTHORIZED=401,
}
